import { getServiceCategory } from '../utils';
import {
	OrderAdditionalServiceGdsServiceServiceType,
	SelectedSeatFragment,
	PassengerFragment,
	CheckinPassengerFragment
} from '@websky/graphql';
import { DataLayerService } from '../OrderDataLayer/types';
import Base from './Base';
import { CheckoutCheckinOrder } from '../../DataLayerAnalytics/types';
import { ChangedService, Diff } from './types';

class Seat extends Base {
	protected orderBeforeChange: CheckoutCheckinOrder;
	protected orderAfterChange: CheckoutCheckinOrder;

	constructor(orderBeforeChange: CheckoutCheckinOrder, orderAfterChange: CheckoutCheckinOrder) {
		super(orderBeforeChange, orderAfterChange);
	}

	private readonly convertSeatServicesToDataLayerServices = (
		services: SelectedSeatFragment[],
		order: CheckoutCheckinOrder,
		traveller: PassengerFragment | CheckinPassengerFragment
	): DataLayerService[] => {
		const converted: DataLayerService[] = [];

		services.forEach(seatService => {
			const seatInfo = order.additionalServices.gdsServices?.services?.find(
				service => service.id === seatService.seat?.seatService?.id
			);

			converted.push({
				name: seatService.seat?.number ?? 'seat',
				price: seatInfo?.price?.amount ?? seatService.seat?.price?.amount,
				category: getServiceCategory(OrderAdditionalServiceGdsServiceServiceType.Seat),
				segmentId: seatService.segment?.id,
				isRecommend: traveller.preselectedServices?.seats.some(seat => {
					return (
						seat.seat?.number === seatService.seat?.number && seat.segment?.id === seatService.segment?.id
					);
				}),
				count: 1,
				travellersTypes: [traveller.type]
			});
		});

		return converted;
	};

	public diff(): Diff {
		const added: DataLayerService[] = [];
		const removed: DataLayerService[] = [];

		const addedInfo: ChangedService[] = [];
		const removedInfo: ChangedService[] = [];

		this.orderAfterChange?.travellers.forEach((travellerAfterChange, index) => {
			const { added: seatsAdded, removed: seatsRemoved } = this.getTravellersServicesDiff<SelectedSeatFragment>(
				this.orderBeforeChange.travellers[index].services.seats,
				travellerAfterChange.services.seats,
				service => service.seat?.number
			);

			added.push(
				...this.convertSeatServicesToDataLayerServices(
					seatsAdded as SelectedSeatFragment[],
					this.orderAfterChange,
					travellerAfterChange
				)
			);
			removed.push(
				...this.convertSeatServicesToDataLayerServices(
					seatsRemoved as SelectedSeatFragment[],
					this.orderAfterChange,
					travellerAfterChange
				)
			);

			seatsAdded.forEach(seat => {
				addedInfo.push({
					serviceId: seat.seat?.rfisc,
					segmentIds: [seat.segment.id],
					passengerIds: [travellerAfterChange.id]
				});
			});
			seatsRemoved.forEach(seat => {
				removedInfo.push({
					serviceId: seat.seat?.rfisc,
					segmentIds: [seat.segment.id],
					passengerIds: [travellerAfterChange.id]
				});
			});
		});

		return { added, removed, addedInfo, removedInfo };
	}
}

export default Seat;
